var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQtNote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M230.717 193.998a6.98 6.98 0 0 1 6.978 6.978v17.446a6.98 6.98 0 0 1-6.978 6.978H49.283a6.98 6.98 0 0 1-6.978-6.978v-17.446a6.98 6.98 0 0 1 6.978-6.978zm0-69.782a6.98 6.98 0 0 1 6.978 6.978v17.446a6.98 6.98 0 0 1-6.978 6.978H49.283a6.98 6.98 0 0 1-6.978-6.978v-17.446a6.98 6.98 0 0 1 6.978-6.978zm0-69.782a6.98 6.98 0 0 1 6.978 6.978v17.446a6.98 6.98 0 0 1-6.978 6.978H49.283a6.98 6.98 0 0 1-6.978-6.978V61.412a6.98 6.98 0 0 1 6.978-6.978z"
})));
export default SvgQtNote;